import { render, staticRenderFns } from "./PapercleanConfigurazioneIvaListComponent.vue?vue&type=template&id=ffe79b16"
import script from "./PapercleanConfigurazioneIvaListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneIvaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports